import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { useState, useEffect } from "react";
import Product from "../actions/product";
import Controls from "./controls/Controls";
import useTable from "./customHelpers/useTable";

const SaveFromFile = (props) => {
  const { viewAllProducts, addProductFromFile } = Product();
  const [products, setProducts] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const updatedColDefs = [
    ...props.file.colDefs,
    { id: "status", label: "Status" },
  ];
  const filteredData = props.file.data.filter((item) =>
    Object.values(item).some((value) => value)
  );

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(
      filteredData.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      ),
      updatedColDefs,
      filterFn
    );
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    if (filteredData) {
      const { total, quantity } = filteredData.reduce(
        (acc, item) => {
          const price =
            parseFloat(
              item.price?.toString().replace(/\s+/g, "").replace(/,/g, "")
            ) || 0;
          const qty =
            parseInt(item.quantity?.toString().replace(/\s+/g, ""), 10) || 0;
          acc.total += price * qty;
          acc.quantity += qty;
          return acc;
        },
        { total: 0, quantity: 0 }
      );
      setTotalPrice(total);
      setTotalQuantity(quantity);
    }
  }, [filteredData]);
  useEffect(() => {
    getExistingAllProducts();
  }, []);
  const handleSubmit = () => {
    addProductFromFile(filteredData).then((data) => {
      if (data.err) {
        props.NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        props.NotifyMessage({
          message: "Products Added",
          type: "success",
        });
        props.setOpenPopupBulkSave(false);
        props.getAllProducts();
      }
    });
  };
  const getExistingAllProducts = () => {
    viewAllProducts().then((data) => {
      if (data.products) {
        setProducts(data.product);
      }
    });
  };
  return (
    <div>
      <TblContainer>
        <TblHead />
        <TableBody>
          {recordsAfterPagingAndSorting().map((item, index) => {
            if (!item.name) return null;
            const skuExists = products.some((prod) => prod.sku === item.sku);
            const status = skuExists ? "Updated" : "New"; // Determine status

            return (
              <TableRow key={index}>
                {updatedColDefs.map((col, colIndex) => {
                  return (
                    <TableCell key={colIndex}>
                      {col.id === "status" ? (
                        <span
                          style={{ color: status === "New" ? "green" : "red" }}
                        >
                          {status}
                        </span>
                      ) : item[col.id] && item[col.id].length > 10 ? (
                        item[col.id].substring(0, 10) + "..."
                      ) : (
                        item[col.id]
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </TblContainer>
      <TblPagination />
      <Controls.Button text="Submit" onClick={handleSubmit} />
      <div style={{ marginTop: 20 }}>
        <strong>Total Price: </strong>
        {totalPrice.toFixed(2)}
        <br />
        <strong>Total Quantity: </strong>
        {totalQuantity}
      </div>
    </div>
  );
};

export default SaveFromFile;
